// src/pages/DoctorsOverview/DoctorsSelectors.js
export const selectClinicsList = (state) => state.doctors?.clinicsList || [];
export const selectClinicsDetails = (state) => state.doctors?.clinicsDetails || [];
export const selectDoctorsList = (state) => state.doctors?.doctorsList || [];
export const selectLocations = (state) => state.doctors?.locations || [];

export const selectIsClinicModalOpen = (state) => state.doctors?.isClinicModalOpen;
export const selectIsDoctorModalOpen = (state) => state.doctors?.isDoctorModalOpen;
export const selectIsEditClinic = (state) => state.doctors?.isEditClinic;
export const selectIsEditDoctor = (state) => state.doctors?.isEditDoctor;
export const selectSelectedClinic = (state) => state.doctors?.selectedClinic;
export const selectSelectedDoctor = (state) => state.doctors?.selectedDoctor;
